module.exports = __webpack_public_path__ + "static/img/manual-46.4b4639d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-46.png
// module id = k9re
// module chunks = 4